import React, { useState } from "react";
import ModalNuevoEvento from "../../../components/modales/eventos/ModalNuevoEvento";

export default function BotonCrear({ item }) {
  const [show, setShow] = useState();
  return (
    <>
      <ModalNuevoEvento
        open={show}
        setOpen={setShow}
        mood={"Alerta"}
        item={item}
      />
    </>
  );
}
